import React, { useEffect, useState } from 'react';
import { Row, Col, Avatar, Form, Grid } from 'antd';
import { CameraOutlined, UserOutlined } from '@ant-design/icons';
import camera from '../../../assets/images/camera.png';
import ButtonLoader from '../../../components/Button/ButtonLoader';

import { FaArrowLeftLong } from 'react-icons/fa6';
import LabelWithField from '../../../components/LabelWithField';
import { useForm, Controller } from 'react-hook-form';
import LabelWithSelect from '../../../components/LabelWithSelect';
// import { Colors } from '../../config';
import { FaPlus } from 'react-icons/fa6';
import BasicDrawer from '../../../components/Drawer';
import TextField from '../../../components/TextField';
import Button from '../../../components/Button';
import UploadAvatar from '../../../components/UploadAvatar';
import { UseDispatch, useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import useColors from '../../../hooks/useColors';
import { AddProperty, EditUser } from '../../../config/Schema';
import { getSchedules, getUserData } from '../../../config/getApis';
import {
    AppAction,
    SiteManagementAction,
    UserManagementAction,
} from '../../../store/actions';
import { ApiCaller, Colors, Utils } from '../../../config';
import { yupResolver } from '@hookform/resolvers/yup';
import { IoIosArrowForward, IoIosSearch } from 'react-icons/io';
import { HiOutlineBellAlert } from 'react-icons/hi2';
import DropDown from '../../../components/DropDown';
import { FaBars, FaCamera } from 'react-icons/fa';
import { maxSize, minSize } from '../../../config/variables';
import DashboardActionBar from '../../../components/DashboardActionBar';

const EditProfile = () => {

    const { colorPrimary } = useColors();
    const scrn = Grid.useBreakpoint();
    const navigate = useNavigate();

    const userData = useSelector((state) => state?.AppReducer);
    const userDetailData = useSelector(
        (state) => state?.UserManagementReducer?.UserDetailData,
    );
    const user = userData?.user;
    console.log('lalallalal', user);
    const dispatch = useDispatch();
    const id = user?.id;

    // const [drawerStates, setDrawerStates] = useState({
    //     openDrawer: false,
    //     userDetailDrawer: false,
    //     drawerkey: 1,
    //     userid: null,
    // });

    const { data: scheduleData } = useQuery('schedule', getSchedules);
    const { data: currentUserData } = useQuery('currentUsers', getUserData);
    console.log('client data', currentUserData);


    const month = [
        { label: 'jan', value: '1' },
        { label: 'feb', value: '2' },
    ];

    const dropDownSelector = (e) => {
        if (e.key === 'tmp-0') {
            navigate('/MyAvailability');
            return;
        } else if (e.key === 'tmp-1') {
            navigate('/EditProfile');
            return;
        } else if (e.key === 'tmp-2') {
            console.log(e.key);
            navigate('/ChangePassword');
            return;
        }
    };

    const FormDataHandler = async (data) => {
        try {
            console.log('data of file', data);
            setUserAddLoader(true);

            // const file = data?.userimg); // Get the file from the form data
            let updatedData = { ...data }; // Create a copy of the original data to update

            // If there's a file (image), handle uploading
            if (data?.profileImgId && typeof data?.profileImgId === 'object') {
                const formData = new FormData();
                formData.append('file', data?.profileImgId); // Append the image file
                formData.append('type', 'profile'); // Append the type (profile image)
                console.log('file form data 2', data?.profileImgId);

                try {
                    // Upload the image using the ApiCaller
                    const res = await ApiCaller.Post('/media/upload', formData);
                    if (res.status === 200 || res.status === 201) {
                        // If successful, get the image ID from the response and update the data
                        updatedData.profileImgId = res.data?.data?.id;
                    } else {
                        // If upload fails, show error message
                        Utils.showMessage(
                            'error',
                            res?.data?.message || 'Failed to upload image',
                        );
                        return; // Exit the function if image upload fails
                    }
                } catch (err) {
                    // Handle error during the image upload
                    Utils.showMessage(
                        'error',
                        err?.response?.data?.message || 'Error uploading image',
                    );
                    return; // Exit the function if image upload fails
                }
            }

            // Proceed to update the user data
            const response = await ApiCaller.Patch('/user', updatedData);
            console.log('Response:', data);

            // Check if the response is successful
            if (response?.status === 200 && response?.data?.success) {
                Utils.showMessage('success', response?.data?.message);
                dispatch(AppAction.GetCurrentUser());
                // Update the drawer states after successful user data update
                // setDrawerStates({
                //     ...drawerStates,
                //     openDrawer: false,
                //     userDetailDrawer: false,
                //     drawerkey: null,
                // });

                // reset();
                // setReadFile(null);
            }
        } catch (err) {
            // Show error message when there is an exception like network error
            const errorMessage =
                err?.response?.data?.message || 'An error occurred';
            Utils.showMessage('error', errorMessage);
            console.error('Error updating user:', err);
        } finally {
            setUserAddLoader(false); // Stop loading once the request completes
        }
    };

    useEffect(() => {
        reset({
            firstName: currentUserData?.firstName,
            lastName: currentUserData?.lastName,
            email: currentUserData?.email,
            phoneNo: currentUserData?.phoneNo,
            profileImgId:
                currentUserData?.profileImg &&
                    currentUserData?.profileImg?.length > 0
                    ? currentUserData?.profileImg[0]?.id
                    : null,
            // scheduleId: user?.schedules ? user?.schedules[0]?.id : null,
        });
        setReadFile(
            currentUserData?.profileImg &&
                currentUserData?.profileImg?.length > 0
                ? currentUserData?.profileImg[0].url
                : '',
        );
    }, [currentUserData]);

    // useEffect(() => {
    //     dispatch(AppAction.GetCurrentUser());
    // }, []);

    const [readFile, setReadFile] = useState(
        currentUserData?.profileImg ? currentUserData?.profileImg[0]?.id : null,
    );
    const [userAddLoader, setUserAddLoader] = useState(false);
    const [img, setimg] = useState(null);
    const [imgValue, setImageValue] = useState({
        imgSizeValidation: '',
        imgTypeValidation: '',
        isRequired: '',
    });

    useEffect(() => {
        let fileReader,
            isCancel = false;

        fileReader = new FileReader();
        if (img) {
            fileReader.onload = (e) => {
                setReadFile(e?.target?.result);
            };
            fileReader.readAsDataURL(img);
        }

        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        };
    }, [img]);

    const removeProfileImage = () => {
        setReadFile('');
        setimg(null);
        setValue('profileImgId', null);
    };

    const schema = EditUser;
    const fileHandler = (e) => {
        console.log(e);
        const file = e?.target.files[0];
        console.log('file img data', file);

        if (
            file &&
            file.size >= minSize &&
            file.size <= maxSize &&
            ['image/png', 'image/jpeg'].includes(file?.type)
        ) {
            setimg(file);
            setValue('profileImgId', file);
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            return;
        }

        else {
            if (file?.size < minSize || file?.size > maxSize) {
                setImageValue({
                    isRequired: '',
                    imgTypeValidation: '',
                    imgSizeValidation: 'Image size must be between 1KB and 6MB',
                });
                setimg('');
                setValue('profileImgId', null);
                setReadFile('');
                return;
            }
            else if (!['image/png', 'image/jpeg'].includes(file?.type)) {
                setImageValue({
                    isRequired: '',
                    imgSizeValidation: '',
                    imgTypeValidation: 'Type should be either jpeg or png',
                });
                setimg('');
                setValue('profileImgId', null);
                setReadFile('');
                return;
            }
        }
    };

    const phoneNumberFormat = (value) => {
        // Remove any non-numeric characters from the input
        const numbersOnly = value.replace(/\D/g, '');

        // Check if the input is long enough to format
        if (numbersOnly.length <= 3) {
            return `(${numbersOnly}`;
        }
        if (numbersOnly.length <= 6) {
            return `(${numbersOnly.slice(0, 3)}) ${numbersOnly.slice(3)}`;
        }
        return `(${numbersOnly.slice(0, 3)}) ${numbersOnly.slice(3, 6)}-${numbersOnly.slice(6, 10)}`;
    };

    const { handleSubmit, control, reset, setValue, watch } = useForm({
        // resolver: yupResolver(schema),
        mode: 'onChange',
    });

    return (
        <div className="bg-white p-4">

            <DashboardActionBar
                text='Edit Profile'
            />

            <Row className="w-full" style={{}}>
                <form className="w-full">
                    <Row className="w-full flex justify-between">
                        <Row
                            className="py-5 w-full items-center justify-center"
                            // justify={'center'}
                            // align={'middle'}

                            style={{
                                padding: '10px',
                                height: '100px',
                                position: 'relative',
                            }}
                        >
                            <Col
                                style={{
                                    width: '70px',
                                    height: '70px',
                                    borderRadius: '50%',
                                    border: '1px solid #F9F9FA',
                                    background: '#F9F9FA',
                                }}
                                className="flex items-center justify-center relative "
                            >
                                <Controller
                                    control={control}
                                    name="profileImgId"
                                    defaultValue={''}
                                    render={(field, fieldState) => (
                                        <>
                                            <>
                                                <input
                                                    type="file"
                                                    title=""
                                                    className="z-0 cursor-pointer"
                                                    style={{
                                                        borderRadius: '50%',
                                                        width: '100%',
                                                        height: '100%',
                                                        position: 'absolute',
                                                        zIndex: 999,
                                                        opacity: 0,
                                                    }}
                                                    onChange={(e) => {
                                                        fileHandler(e);
                                                    }}
                                                    accept=".png, .jpg, .jpeg"
                                                />
                                            </>
                                        </>
                                    )}
                                />
                                {readFile ? (
                                    <>
                                        <Avatar
                                            className="z-10 absolute w-full h-full"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            src={readFile}
                                        />
                                        <FaCamera
                                            className="absolute z-20 right-0 bottom-0"
                                            size={20}
                                            style={{ color: colorPrimary }}
                                        />
                                        <button
                                            type="button"
                                            onClick={removeProfileImage}
                                            style={{ zIndex: 1000 }}
                                            className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs leading-none"
                                        >
                                            ×
                                        </button>
                                    </>
                                ) : (
                                    <Avatar
                                        className="z-0 absolute w-full h-full flex items-center justify-center"
                                        icon={<FaCamera />}
                                    />
                                )}
                            </Col>

                            {/* user image validation  */}
                            <p
                                style={{ color: Colors.Error, width: '100%' }}
                                className="text-center"
                            >
                                {imgValue && imgValue.imgSizeValidation ? (
                                    <p>{imgValue.imgSizeValidation}</p>
                                ) : imgValue && imgValue.imgTypeValidation ? (
                                    <p>{imgValue.imgTypeValidation}</p>
                                ) : imgValue.isRequired ? (
                                    <p>{imgValue.isRequired}</p>
                                ) : (
                                    ''
                                )}
                            </p>
                        </Row>

                        <Row className="w-full sm:w-6/12 pr-2">
                            <Controller
                                control={control}
                                name="firstName"
                                defaultValue={''}
                                render={({ field, fieldState }) => (
                                    <>
                                        <LabelWithField
                                            labeltext={'First Name'}
                                            field={field}
                                            type={'text'}
                                            labelClass={'font-normal'}
                                            inputClass={
                                                'outline-none h-10 rounded'
                                            }
                                        />
                                        {fieldState?.error && (
                                            <p style={{ color: Colors.Error }}>
                                                {fieldState?.error.message}
                                            </p>
                                        )}
                                    </>
                                )}
                            />
                        </Row>

                        <Row className="w-full sm:w-6/12">
                            <>
                                <Controller
                                    control={control}
                                    name="lastName"
                                    render={({ field, fieldState }) => (
                                        <>
                                            <LabelWithField
                                                labeltext={'Last Name'}
                                                field={field}
                                                type={'text'}
                                                labelClass={'font-normal'}
                                                inputClass={
                                                    'outline-none h-10 rounded'
                                                }
                                            />
                                            {fieldState?.error && (
                                                <p
                                                    style={{
                                                        color: Colors.Error,
                                                    }}
                                                >
                                                    {fieldState?.error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </>
                        </Row>

                        <Row className="w-full sm:w-2/4 pr-2">
                            <>
                                <Controller
                                    control={control}
                                    name="phoneNo"
                                    render={({
                                        field: { value, onChange },
                                        fieldState,
                                    }) => (
                                        <div className="flex flex-col py-4 w-full">
                                            <label
                                                className={'font-normal'}
                                                style={{
                                                    color: Colors.LabelColor,
                                                }}
                                            >
                                                {'Phone Number'}
                                            </label>
                                            <input
                                                type={'string'}
                                                value={value}
                                                onChange={onChange}
                                                onBlur={(e) => {
                                                    const formattedNumber =
                                                        phoneNumberFormat(
                                                            e.target.value,
                                                        );
                                                    if (
                                                        formattedNumber?.length ===
                                                        14
                                                    ) {
                                                        // clearErrors('phoneNo');
                                                        onChange(
                                                            formattedNumber,
                                                        );
                                                    }
                                                }}
                                                className={`pl-2.5 outline-none h-10 rounded`}
                                                style={{
                                                    background:
                                                        Colors.LightGray,
                                                }}
                                            />
                                            {fieldState?.error && (
                                                <p
                                                    style={{
                                                        color: Colors.Error,
                                                    }}
                                                >
                                                    {fieldState?.error.message}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                />
                            </>
                        </Row>

                        <Row className="w-full sm:w-2/4">
                            <>
                                <Controller
                                    control={control}
                                    name="email"
                                    render={({ field, fieldState }) => (
                                        <>
                                            <LabelWithField
                                                // disabled={
                                                //     userDetailData?.email
                                                //         ? true
                                                //         : false
                                                // }
                                                disabled={true}
                                                labeltext={'Email'}
                                                field={field}
                                                type={'email'}
                                                labelClass={'font-normal'}
                                                inputClass={
                                                    'outline-none h-10 rounded'
                                                }
                                            />
                                            {fieldState?.error && (
                                                <p
                                                    style={{
                                                        color: Colors.Error,
                                                    }}
                                                >
                                                    {fieldState?.error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </>
                        </Row>
                    </Row>

                    <Row className="w-full flex justify-end">
                        <ButtonLoader
                            btnHandler={handleSubmit(FormDataHandler)} // Handle form submission
                            loader={userAddLoader} // Pass the loading state to the button
                            style={{
                                background: colorPrimary,
                                color: Colors.White,
                            }}
                            className={
                                'cursor-pointer my-2 mx-1 h-10 rounded-none px-8'
                            }
                            text={
                                'Update User'
                            }
                        />
                    </Row>
                </form>
            </Row>

            <br />
        </div>
    );
};

export default EditProfile;
